import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  @media (${MEDIA_QUERIES.laptopL}) {
    margin-bottom: 4px;
  }
  @media (${MEDIA_QUERIES.desktopL}) {
    margin-bottom: 16px;
  }
`;

export const Heading = styled.a`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  @media (${MEDIA_QUERIES.laptopL}) {
    font-size: 13px;
  }
  @media (${MEDIA_QUERIES.desktopL}) {
    font-size: 14px;
  }
`;

export const Text = styled.span`
  font-family: 'Inter', sans-serif;
  color: #808080;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
`;
